export const validateConfig = () => {
  const required = ['REACT_APP_API_URL'];
  const missing = required.filter(key => !process.env[key]);
  
  if (missing.length > 0) {
    console.error('Missing required environment variables:', missing);
    return false;
  }
  
  return true;
};

export const getConfigInfo = () => {
  return {
    apiUrl: process.env.REACT_APP_API_URL,
    wsUrl: process.env.REACT_APP_WS_URL,
    environment: process.env.REACT_APP_ENVIRONMENT || 'development',
    nodeEnv: process.env.NODE_ENV
  };
};

export const logConfig = () => {
  const config = getConfigInfo();
  console.log('🔧 App Configuration:', config);
  return config;
};
